function resetSearch() {
  document.getElementById("search-resources").value = "";
  updateResources();
  document.getElementById('resetSearchButton').style.display = "none";
}

function resetFilters() {
  if (window.getComputedStyle(document.getElementById("filter-one").parentElement).display != 'none') {
      document.getElementById("filter-one").selectedIndex = 0;
  }
  if (window.getComputedStyle(document.getElementById("filter-two").parentElement).display != 'none') {
    document.getElementById("filter-two").selectedIndex = 0;
  }
  updateOptionsVisibility(filterOne, filterTwo, filterMapping);
  updateOptionsVisibility(filterTwo, filterOne, filterMapping);
  updateResources();
}

var filterOne = document.getElementById('filter-one');
var filterTwo = document.getElementById('filter-two');

var filterMapping = {
  'filter-one': {
    'all': ['all', 'hosted-exchange', 'microsoft-azure', 'microsoft-365', 'microsoft-project', 'microsoft-visio', 'sql-server', 'windows-server'],
    'blogs': ['all', 'company-news', 'microsoft-azure', 'microsoft-365', 'windows-server'],
    'guides': ['all', 'hosted-exchange', 'microsoft-azure', 'microsoft-365', 'microsoft-project', 'microsoft-visio', 'sql-server', 'windows-server'],
    'licensing-calculators': ['all', 'sql-server', 'windows-server'],
    'testimonials': ['all'],
    'video-tutorials': ['all', 'microsoft-azure', 'microsoft-365', 'windows-server'],
    'webinars': ['all', 'microsoft-azure', 'microsoft-365', 'sql-server', 'windows-server']
  },
  'filter-two': {
    'all': ['all', 'blogs', 'guides', 'licensing-calculators', 'testimonials', 'video-tutorials', 'webinars'],
    'company-news': ['all', 'blogs'],
    'hosted-exchange': ['all', 'guides'],
    'microsoft-azure': ['all', 'blogs', 'guides', 'video-tutorials', 'webinars'],
    'microsoft-365': ['all', 'blogs', 'guides', 'video-tutorials', 'webinars'],
    'microsoft-project': ['all', 'guides'],
    'microsoft-visio': ['all', 'guides'],
    'sql-server': ['all', 'guides', 'licensing-calculators', 'webinars'],
    'windows-server': ['all', 'blogs', 'guides', 'licensing-calculators', 'video-tutorials', 'webinars']
  }
};

function updateOptionsVisibility(selectedFilter, affectedFilter, mapping) {
  var selectedValue = selectedFilter.value;
  var optionsToShow = mapping[selectedFilter.id][selectedValue] || [];

  for (var option of affectedFilter.options) {
    option.style.display = optionsToShow.includes(option.value) || selectedValue === 'all' ? 'block' : 'none';
  }
}

filterOne.addEventListener('change', function () {
  updateOptionsVisibility(filterOne, filterTwo, filterMapping);
});

filterTwo.addEventListener('change', function () {
  updateOptionsVisibility(filterTwo, filterOne, filterMapping);
});

updateOptionsVisibility(filterOne, filterTwo, filterMapping);
updateOptionsVisibility(filterTwo, filterOne, filterMapping);

function updateResources() {
  var searchQuery = document.getElementById("search-resources").value.trim().toLocaleLowerCase();
  var filterOne = document.getElementById("filter-one").value.trim().toLocaleLowerCase();
  var filterTwo = document.getElementById("filter-two").value.trim().toLocaleLowerCase();
  var searchCount = 0;

  // updateFilters();

  if (filterOne != "all"  && window.getComputedStyle(document.getElementById("filter-one").parentElement).display != 'none') {
    document.getElementById('clear-filters-btn').style.display = 'block';
  } else if (filterTwo != "all" && window.getComputedStyle(document.getElementById("filter-two").parentElement).display != 'none') {
    document.getElementById('clear-filters-btn').style.display = 'block';
  } else {
    document.getElementById('clear-filters-btn').style.display = 'none';
  }

  if (searchQuery.length > 0) {
    document.getElementById('search-string').innerHTML = "" + searchQuery;
    document.getElementById('no-results-string').innerHTML = ' for "' + searchQuery + '"';
  } else {
    document.getElementById('search-string').innerHTML = ""
    document.getElementById('no-results-string').innerHTML = "";
  }

  if (searchQuery.length > 0 || filterOne != "All"  || filterTwo != "All") {

    if (searchQuery.length > 0) {
      document.getElementById('resetSearchButton').style.display = "flex";
    }

    var hasResults = false;
    document.querySelectorAll(".resource-card-wrapper").forEach((card) => {

      let cardProduct = card.getAttribute("data-product");
      let cardCategory = card.querySelector(".card-category").getAttribute("data-category");
      let cardTitle = card.querySelector(".card-title").innerHTML.trim().toLocaleLowerCase();
      let cardBody = card.querySelector(".card-text").innerHTML.trim().toLocaleLowerCase();

      let matchesSearchText = cardTitle.includes(searchQuery) || cardBody.includes(searchQuery) || searchQuery == "";
      let matchesCategory = filterOne == "all" || cardCategory == filterOne;
      let matchesProduct = filterTwo == "all" || cardProduct == filterTwo;

      if (matchesSearchText && matchesCategory && matchesProduct)
      {
        card.style.display = "block";
        hasResults = true;
        searchCount += 1;
      } else {
        card.style.display = "none";
      }
    });

    if (hasResults) {
      document.getElementById("no-results-title").style.display = "none";
      console.log("The search query is: " + searchQuery);
      searchQuery != '' ? (document.getElementById("search-title").style.display = "flex") : (document.getElementById("search-title").style.display = "none");
    } else {
      document.getElementById("search-title").style.display = "none";
      document.getElementById("no-results-title").style.display = "block";
    }

  } else {

    document.getElementById('resetSearchButton').style.display = "none";
    document.querySelectorAll(".resource-card-wrapper").forEach((card) => {
      card.style.display = "block";
    });
    document.getElementById("search-title").style.display = "none";
  }

  if (searchQuery == "") {
    document.getElementById("search-title").style.display = "none";
    document.getElementById('resetSearchButton').style.display = "none";
  }

  document.getElementById("search-count").innerHTML = searchCount;

  if (searchCount > 1) {
    document.getElementById('search-plural').style.display = 'contents';
  } else {
    document.getElementById('search-plural').style.display = 'none';
  }
}

function scrollToSection(id) {
  const section = document.querySelector("#" + id);
  section.scrollIntoView({ behavior: "smooth" });
}

const urlSearchParams = new URLSearchParams(window.location.search);
const searchQuery = urlSearchParams.get('searchQuery');
const category = urlSearchParams.get('category');
const product = urlSearchParams.get('product');

searchQuery && (document.getElementById("search-resources").value = searchQuery);

if (category) {
  var selectOne = document.getElementById("filter-one");
  for (let i = 0; i < selectOne.options.length; i++) {
    if (selectOne.options[i].value.toLocaleLowerCase() == category.toLocaleLowerCase()) {
      selectOne.selectedIndex = i;
      break;
    }
  }
}

if (product) {
  var selectTwo = document.getElementById("filter-two");
  for (let i = 0; i < selectTwo.options.length; i++) {
    if (selectTwo.options[i].value.toLocaleLowerCase() == product.toLocaleLowerCase()) {
      selectTwo.selectedIndex = i;
      break;
    }
  }
}

updateResources();
